// src/task/TaskCard.js
import React from 'react';
import { Star } from 'lucide-react';

const statusLabels = {
  '1': { label: 'En attente', bg: 'bg-blue-100', text: 'text-blue-800' },
  '2': { label: 'En cours', bg: 'bg-amber-100', text: 'text-amber-800' },
  '3': { label: 'Prêt', bg: 'bg-green-100', text: 'text-green-800' },
};

const TaskCard = ({
  id,
  title,
  content,
  priorite,
  etape,
  type,
  status,
  createur,
  deadlineClient,
  isMobile
}) => {
  const renderStars = (rating) =>
    Array.from({ length: 3 }, (_, index) => (
      <Star
        key={index}
        className={`${isMobile ? 'w-2.5 h-2.5' : 'w-3 h-3'} ${index < rating ? 'fill-amber-600 text-amber-600' : 'text-gray-300'}`}
      />
    ));

  return (
    <div className="bg-white border border-gray-200 p-2 mb-2 rounded-md shadow-sm hover:shadow-md transition-all duration-200 hover:border-terracotta/30">
      <div className="flex items-start justify-between mb-1">
        <div>
          <h3 className={`${isMobile ? 'text-xs' : 'text-sm'} font-semibold text-gray-800 line-clamp-1`}>{title}</h3>
        </div>
        <div className="flex items-center gap-0.5">
          {renderStars(Number(priorite))}
        </div>
      </div>

      <p className={`${isMobile ? 'text-[10px]' : 'text-[11px]'} text-gray-600 mb-2 line-clamp-1 leading-snug truncate`}>{content}</p>

      <div className="flex items-center justify-between text-[10px] font-medium mb-1">
        <span
          className={`${statusLabels[status]?.bg || 'bg-gray-100'} ${statusLabels[status]?.text || 'text-gray-600'} rounded-full px-1 py-0.5`}
        >
          {statusLabels[status]?.label || status}
        </span>
      </div>

      <div className="pt-1 border-t border-gray-100 text-[10px] text-gray-600">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1">
            <span className="font-medium text-gray-500">Deadline:</span>
            <span className={new Date(deadlineClient) < new Date() ? 'text-red-500' : ''}>
              {deadlineClient}
            </span>
          </div>
          <div className="flex items-center gap-1">
            <span>{type}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskCard;